<ion-header class="modal-header">
  <div class="modal-title">
    {{ emailRule?.id ? "Edit Inbox" : "Create Email Inbox" }}
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" *ngIf="emailRule">
  <ion-card-header *ngIf="!emailRule.id">
    <ion-input
      [(ngModel)]="emailRule.name"
      class="input-field big-title-input"
      placeholder="Name your inbox (ex: 'Email Support')"
      autocapitalize="sentences"
    >
    </ion-input>
  </ion-card-header>
  <ion-list>
    <ion-item>
      <h3 class="list-header">Email Forwarding</h3>
      <ion-button fill="clear" slot="end" (click)="showEmailHelpdesk()">
        <ion-icon name="information-circle" class="padded-icon"></ion-icon>
        Learn how to set up forwarding
      </ion-button>
    </ion-item>
    <ion-item>
      <ion-label> Enter company email address: </ion-label>
      <ion-input
        slot="end"
        style="text-align: right"
        placeholder="Ex: support@mydomain.com"
        [(ngModel)]="emailRule.email"
        type="email"
      ></ion-input>
    </ion-item>
    <ion-item>
      <ion-label> Send replies from </ion-label>
      <ion-select
        [(ngModel)]="emailRule.alwaysUseGenericEmailAddress"
        interface="popover"
        slot="end"
      >
        <ion-select-option [value]="true">
          This email address&nbsp;&nbsp;&nbsp;&nbsp;
        </ion-select-option>
        <ion-select-option [value]="false">
          User's email address&nbsp;&nbsp;&nbsp;&nbsp;
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-label> Reply with name </ion-label>
      <ion-input
        [(ngModel)]="emailRule.replyName"
        placeholder="Ex: Support"
        slot="end"
        style="text-align: right"
      ></ion-input>
    </ion-item>
    <ion-item>
      <ion-label> Forward emails to:</ion-label>
      <div class="email-section flex-space-between" slot="end">
        <span>{{ getForwardEmail(emailRule) }}</span>
        <a
          ngxTippy
          data-tippy-content="Copy to clipboard"
          (click)="copyToClipboard(emailRule)"
        >
          <ion-icon name="copy-outline" style="margin-left: 12px"></ion-icon>
        </a>
      </div>
    </ion-item>
  </ion-list>

  <ion-list>
    <ion-item>
      <h3 class="list-header">Slack Channel</h3>
    </ion-item>
    <ion-item>
      <ion-label>Post to Slack channel: </ion-label>
      <div slot="end">
        <app-channel-selector
          [channel]="emailRule.slackChannel"
          (channelDidChange)="onRuleChannelChanged($event)"
          [defaultInternalOnly]="true"
          [hideUnlinkButton]="true"
        ></app-channel-selector>
      </div>
    </ion-item>
  </ion-list>

  <ion-card-title class="card-title">
    <h3 class="list-header">SLA</h3>
  </ion-card-title>
  <app-support-steps
    *ngIf="emailRule.supportSteps"
    [initialSupportSteps]="emailRule.supportSteps"
    (didChange)="supportStepsDidChange($event)"
  >
  </app-support-steps>

  <ion-card-title
    class="card-title flex-space-between"
    style="align-items: center"
  >
    <h3 style="margin-bottom: 18px" class="list-header">Autoresponder</h3>
  </ion-card-title>

  <app-autoresponder
    [isDefault]="false"
    [initialAutoresponder]="emailRule.autoresponder"
    (autoresponderDidChange)="autoresponderDidChange(emailRule, $event)"
    [projectId]="project?.id ?? undefined"
  ></app-autoresponder>

  <ion-card-title class="card-title">
    <h3 class="list-header">Blocked Emails & Domains</h3>
  </ion-card-title>
  <ion-list lines="none">
    <ion-item
      *ngFor="let entry of sortBlocklist(); let i = index"
      class="blocklist-item"
    >
      <ion-label color="danger">{{ entry }}</ion-label>
      <ion-button fill="clear" color="dark" (click)="deleteBlocklistEntry(i)">
        <ion-icon name="close-circle"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item>
      <ion-input
        placeholder="Add an email address (name@mail.com) or a domain (mail.com) and hit enter"
        [(ngModel)]="blockedEmailField"
        (keyup.enter)="addBlockedEmail()"
      ></ion-input>
    </ion-item>
  </ion-list>

  <ion-card-title class="card-title" *ngIf="emailRule?.id">
    <h3 class="list-header">Advanced</h3>
  </ion-card-title>
  <ion-list *ngIf="emailRule?.id">
    <ion-item>
      <ion-label text-wrap>
        <h3>Email Inbox ID</h3>
        <p>To be used in our API or Automations systems</p>
      </ion-label>
      <ion-label slot="end" class="email-section">{{
        emailRule?.id
      }}</ion-label>
    </ion-item>
  </ion-list>
</ion-content>
<ion-footer>
  <div class="flex-space-between" style="padding: 18px">
    <div class="flexed-align-center">
      <ion-button
        fill="clear"
        color="dark"
        (click)="selectProject()"
        class="button-dark-border"
        *ngIf="!emailRule?.id && !hideProject"
      >
        <ion-icon
          [name]="project?.name ? 'custom-project' : 'custom-project-outline'"
          class="padded-icon button-icon"
        ></ion-icon>
        {{
          project?.name ? project.name : project?.id ?? "Select a project..."
        }}
        <ion-icon
          name="chevron-down-outline"
          class="icon-padded-left button-icon"
        ></ion-icon>
      </ion-button>
      <ion-button
        color="success"
        (click)="save()"
        class="save-button"
        [disabled]="!featureEnabled || isUpdatingInbox"
      >
        {{ emailRule?.id ? "Save changes" : "Save" }}
      </ion-button>
    </div>
    <div class="flexed-align-center">
      <ion-button fill="clear" (click)="dismiss()"> Cancel </ion-button>
      <ion-button
        color="danger"
        fill="clear"
        (click)="delete()"
        *ngIf="emailRule?.id"
        [disabled]="isUpdatingInbox"
        >Delete</ion-button
      >
    </div>
  </div>
</ion-footer>
